export class Reproceso {
    idDispersion: number;
    tipoReproceso: number;
    metodoPago: string;
}